// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__iaBYy","container":"style_container___DdRG","links":"style_links__ZbbBB","link":"style_link__qQn0N"};